import AbstractDebugView from "../../core/view/AbstractDebugView";
import TextLayout from '../../../app/ui/TextLayout';
import ClipboardUtil from "../../../../../lib/html5-software-library/src/ranj/util/ClipboardUtil";
import * as dat from 'dat.gui';
import { camelCaseToSpaces } from "../../../../../lib/html5-software-library/src/ranj/util/StringUtil";

export default class TextLayoutTweakerController extends AbstractDebugView {

    constructor(stage) {
        super(null, null, "TextLayoutTweaker");
        this._stage = stage;

        this.onChange = this.onChange.bind(this);
    };

    destroy() {
        this.closePopup();
        super.destroy();
    };

    
    showPopup() {
        //Toggle open/close
        if (this._menu) {
            this.closePopup();
            return;
        }
        this.target = this._stage;
        this.bindTexts();
        const menu = new dat.GUI({name: "TextLayoutTweaker", closeOnTop:true});
        menu.width = 180;

        menu.add(TextLayout, "xOffset", -5, 5).step(.05).onChange(this.onChange).listen();
        menu.add(TextLayout, "xFactor", -2, 2).step(.001).onChange(this.onChange).listen();
        menu.add(TextLayout, "yOffset", -5, 5).step(.05).onChange(this.onChange).listen();
        menu.add(TextLayout, "yFactor", -2, 2).step(.001).onChange(this.onChange).listen();
        
        const methodRelays = {};
        ['resetValues', 'outputValues', 'clearTextReferences'].forEach(methodName => {
            const label = camelCaseToSpaces(methodName).toLowerCase();
            methodRelays[label] = this[methodName].bind(this);
            const controller = menu.add(methodRelays, label);
            //hacky method to avoid button labels being truncated
            const elem = controller.domElement.parentElement.children[0];
            elem.style.width = "90%";
        })

        this._menu = menu;
        window.menu = menu;
        menu.domElement.parentNode.style.zIndex = 99;
        //hacky method to use dat.gui close button for our own purposes
        menu.domElement.getElementsByClassName("close-button")[0].onclick = this.closePopup.bind(this);
    }

    closePopup() {
        if (this._menu) {
            this._menu.destroy();
            this._menu = null;
        }
        this.clearTextReferences();
    }

    onChange(value) {
        this.applyValues();
    }

    applyValues() {
        const texts = this.texts;
        if (!texts.length) {
            this.bindTexts();
        }
        const n = texts.length;
        for (let i = 0; i < n; i++) {
            const tf = texts[i];
            //First reset to originals, then apply fix
            const origs = tf.originalValues;
            if (!origs) {
                continue;
            }
            tf.x = origs.x;
            tf.y = origs.y;

            TextLayout.fixTextField(tf);
        }
    }

    /**
     * Collect all Text instances currently on target
     */
    bindTexts() {
        this.texts = initTarget(this.target);
    }

    /**
     * Clear all references to Text instances
     */
    clearTextReferences() {
        console.log("TextLayoutTweaker.clearTextReferences");
        this.texts = [];
    }

    /**
     * Output TextLayout parameter values to console and clipboard.
     */
    outputValues() {
        const lines = [
            "TextLayout.xOffset = " + TextLayout.xOffset + ";",
            "TextLayout.xFactor = " + TextLayout.xFactor + ";",
            "TextLayout.yOffset = " + TextLayout.yOffset + ";",
            "TextLayout.yFactor = " + TextLayout.yFactor + ";",
        ]
        const str = lines.join("\n");
        console.log("TextLayoutTweaker.outputValues: ");
        console.log(str);
        copyToClipboard(str);
    }

    /**
     * Reset Text intance values for x, y
     */
    resetValues() {
        console.log("TextLayoutTweaker.resetValues");
        TextLayout.xOffset = originalValues.xOffset;
        TextLayout.xFactor = originalValues.xFactor;
        TextLayout.yOffset = originalValues.yOffset;
        TextLayout.yFactor = originalValues.yFactor;
        this.applyValues();
    }
}

const originalValues = {};
originalValues.xOffset = TextLayout.xOffset;
originalValues.xFactor = TextLayout.xFactor;
originalValues.yOffset = TextLayout.yOffset;
originalValues.yFactor = TextLayout.yFactor;

//At load time, overwrite TextLayout.fixTextField, so we can record
//original Text properties, which we need to reset them before
//applying tweaked values.    
const fixTextFieldOriginal = TextLayout.fixTextField;
TextLayout.fixTextField = function(target, markTarget, logInfo) {
    if (!target.originalValues) {
        const origs = {};
        origs.x = target.x;
        origs.y = target.y;
        target.originalValues = origs;
    }
    fixTextFieldOriginal(target, markTarget, logInfo);
}

const initTarget = function(target) {
    //collect all textfields from target display tree
    const texts = collectTexts(target);
    texts.forEach(tf => {
        if (!tf.originalValues) {
            const origs = {};
            origs.x = tf.x;
            origs.y = tf.y;
            tf.originalValues = origs;
        }
    });
    console.log("TextLayoutTweaker/initTarget ", texts);
    return texts;
}

const collectTexts = (container, res) => {
    res = res || [];
    const children = container.children, n = container.numChildren;
    for (let i = 0; i < n; i++) {
        var child = children[i];
        if (child.font && !isNaN(child.lineHeight)) {
            res.push(child);
        }
        else if (child.children) {
            collectTexts(child, res);
        }
    }
    return res;
}


function copyToClipboard(text) {
    ClipboardUtil.copy(text);
    console.log("copied to clipboard.");
}
